export default __webpack_public_path__ + "static/hoarding-cleanout-icon-64a3da1f241f1af4024a87c40062ad92.png";